import { useState } from 'react';
import BrokerBankEditModal from './editModals/BrokerBankEditModal';

function BrokerBankDetailsTab({ bank_details = [], brokerId, onUpdated, canEditBrokers }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Bank Details</h5>
        {canEditBrokers && (
        <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowModal(true)}>
          <i className="fa fa-edit me-1"></i> Edit Bank Details
        </button>
        )}
      </div>

      {bank_details.length === 0 ? (
        <p className="text-muted">No bank details available.</p>
      ) : (
        
          <div className="border rounded p-3 mb-2 fs-85" >
            <p className="mb-1"><strong>Account Holder Name:</strong> {bank_details.account_name}</p>
            <p className="mb-1"><strong>Bank Name:</strong> {bank_details.bank}</p>
            <p className="mb-1"><strong>Account No:</strong> {bank_details.account_number}</p>
            <p className="mb-1"><strong>IFSC:</strong> {bank_details.ifsc}</p>
            <p className="mb-0"><strong>Branch:</strong> {bank_details.branch}</p>
            <p className="mb-0"><strong>Account Type:</strong> {bank_details.account_type}</p>
          </div>
        
      )}
{canEditBrokers && (
      <BrokerBankEditModal show={showModal} onHide={() => setShowModal(false)} brokerId={brokerId} bank_details={bank_details} onUpdated={onUpdated} />
        )}
    </div>
  );
}

export default BrokerBankDetailsTab;